import type { SymbolSetItem } from "../../../../api/types";

/** Where a shape comes from, in plain words. */
export function originWords(item: SymbolSetItem): string {
  if (item.origin === "loaded") return item.changed ? "From the library, changed here (the change waits for the SME)" : "From the library";
  return "Made in this discipline";
}

export function kindWord(kind: "symbol" | "line_style"): string {
  return kind === "line_style" ? "line style" : "symbol";
}

export function usedWords(item: SymbolSetItem): string {
  const n = item.used_by.length;
  return n === 0 ? "Not used yet" : n === 1 ? "Used by 1 element" : `Used by ${n} elements`;
}

/** A code made from words: lower case, underscores, as the server's key rule. */
export function codeFrom(words: string): string {
  const code = words
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  return /^[0-9]/.test(code) ? `v_${code}` : code;
}

/** The ending a code takes for a kind of drawing: PidSheet gives pid, ArchitectureDrawing gives architecture_drawing. */
export function drawingSuffix(kindOfDrawing: string): string {
  const name = kindOfDrawing.endsWith("Sheet") && kindOfDrawing.length > 5 ? kindOfDrawing.slice(0, -5) : kindOfDrawing;
  return name.replace(/(?!^)([A-Z])/g, "_$1").toLowerCase();
}

export const SIDES = [
  { value: "north", label: "Up (north)" },
  { value: "east", label: "Right (east)" },
  { value: "south", label: "Down (south)" },
  { value: "west", label: "Left (west)" },
];
